import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Feature10 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    return (
      <div
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.page}>
          <OverPack
            {...dataSource.content}
          >
            <TweenOne
              animation={{
                x: 0,
                duration: 500,
              }}
              style={{ transform: 'translateX(-180px)' }}
              {...dataSource.content.left}
            >
              {
              dataSource.content.left.children.map(getChildrenToRender)
            }
            </TweenOne>
            <TweenOne
              animation={{
                x: 0,
                duration: 500,
              }}
              style={{ transform: 'translateX(180px)' }}
              key="img"
              {...dataSource.content.right}
              data-edit="image"
            >
              <img src={dataSource.content.right.children} width="100%" alt="img" />
            </TweenOne>
          </OverPack>
        </div>

      </div>
    );
  }
}
export default Feature10;
